<spinner *ngIf="generalLoader"></spinner>
<div [ngStyle]="generalLoader ? {'display': 'none'}: {'display': 'block'}">
    <router-outlet></router-outlet>
</div>
